const PROFILE_ID = '2751686654039572'

export const canClearInheritedBid = (profileId: unknown) => String(profileId) === PROFILE_ID
